import { logWarning, logError } from '../utils/errorHandlers';

const padNumber = (value) => String(value).padStart(2, '0');

const buildQueryUrl = (baseUrl, { year, month }) => {
  const sanitizedBase = baseUrl.replace(/\/?$/, '');
  const delimiter = sanitizedBase.includes('?') ? '&' : '?';
  const normalizedMonth = padNumber(month);
  const normalizedYear = String(year);
  return `${sanitizedBase}${delimiter}year=${normalizedYear}&month=${normalizedMonth}`;
};

export const getCalendarApiBaseUrl = () => {
  const raw = process.env.REACT_APP_CALENDAR_API_URL;
  return raw ? raw.trim() : '';
};

export const fetchCalendarMonth = async ({ year, month } = {}) => {
  const baseUrl = getCalendarApiBaseUrl();

  if (!baseUrl) {
    const error = new Error('[calendarService] Missing REACT_APP_CALENDAR_API_URL');
    logWarning('[calendarService]', error);
    throw error;
  }

  if (!year || !month) {
    throw new Error('[calendarService] Missing year or month parameter');
  }

  const requestUrl = buildQueryUrl(baseUrl, { year, month });

  let response;
  try {
    response = await fetch(requestUrl, {
      headers: {
        Accept: 'application/json',
      },
    });
  } catch (networkError) {
    logError('[calendarService] Network error while fetching calendar month', networkError);
    throw networkError;
  }

  if (!response.ok) {
    const error = new Error(`[calendarService] Failed to fetch calendar month (${response.status})`);
    logError('[calendarService] HTTP error', error);
    throw error;
  }

  const payload = await response.json();

  const { year: responseYear, month: responseMonth, from, to, events } = payload;

  return {
    year: responseYear ?? year,
    month: responseMonth ?? month,
    from: from ?? null,
    to: to ?? null,
    events: Array.isArray(events) ? events : [],
  };
};
